import { Stepper } from '@avanta/shared/components/Stepper';
import { Button } from '@avanta/shared/components/ui/Button';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { Headset } from 'lucide-react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import Logo from '@/assets/itae-agendar.svg';
import { ROUTES } from 'constants/routes';
import { type StepDefinition } from 'pages/AppointmentsReserve/hooks/useStepNavigation';
import { AppointmentsReservePayload } from '../../../types';
import { getStepperWidth } from './utils';

type TopNavProps = {
  steps: StepDefinition[];
  currentStepIndex: number;
};

export const TopNav = ({ steps, currentStepIndex }: TopNavProps): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.APPOINTMENTS);
  const { watch } = useFormContext();
  const flow = watch(AppointmentsReservePayload.flow);

  return (
    <div className="relative mb-14">
      <header className="mx-auto flex h-16 w-full max-w-7xl items-center justify-between px-18">
        <Link to={ROUTES.HOME} className="flex items-center">
          <img src={Logo} alt="itae" className="h-12 w-auto object-contain" />
        </Link>
        <Button
          variant="terciary"
          // eslint-disable-next-line no-alert
          onClick={() => window.alert('Aún no implementado')}
          icon="leading"
        >
          <Headset className="size-5" />
          {t('Nav.support', { ns: LOCIZE_NS.COMMON })}
        </Button>
      </header>
      <div className="container mx-auto flex max-w-3xl flex-col items-center gap-4.5 px-4">
        <h1 className="mt-6 text-center text-2xl font-medium leading-7 text-denim-800">
          {t(`AppointmentsReserve.${flow}.title`)}
        </h1>
        <Stepper
          steps={steps}
          currentStep={currentStepIndex}
          i18nKey="AppointmentsReserve.Steps"
          i18nNs="appointments"
          className={getStepperWidth(steps.length)}
        />
      </div>
    </div>
  );
};
